import { NotifyHelper } from "../../../helpers/toast"
import { eDotThiActions } from "../../action-types/to-chuc-thi/IDotThiActions"
import { generateActionForKey, generateActions } from "../generateActions"

export const dotThiActions = {
    ...generateActions(eDotThiActions, "DOT_THI"),
    ...generateActionForKey(eDotThiActions, "DOT_THI", "LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),
}